import { FETCH_ERRORS, CLEAR_ERRORS } from './types';

const initialState = {
  resource: '',
  code: '',
  message: '',
  status: '',
  payload: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ERRORS:
      return { ...state, ...action.payload };
    case CLEAR_ERRORS:
      return { ...state, ...initialState };
    default:
      return state;
  }
}